export const searchProfile = id => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection("profile")
      .doc(id)
      .get()
      .then(function(doc) {
        if (doc.exists) {
          dispatch({ type: "PROFILE_FOUND" });
        } else {
          dispatch({ type: "NO_PROFILE" });
        }
      })
      .catch(function(error) {
        dispatch({ type: "ERROR_SEARCH_PROFILE", error: error });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/searchAction.tsx